import { render } from "./TheCartOrderReceivingDelivery.vue?vue&type=template&id=7b47dc73"
import script from "./TheCartOrderReceivingDelivery.vue?vue&type=script&lang=js"
export * from "./TheCartOrderReceivingDelivery.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__